module.exports = "query ($id: ID!) {\n  ModelTemplate(id: $id) {\n    id\n    ofType\n    data\n    customFields\n    themeSettings\n  }\n}\n"